import { Tool } from '@/types/tool';
import { tools } from './toolsData';

export { tools };

// Helper functions for tool management
export const getToolById = (id: string): Tool | undefined => {
  return tools.find(tool => tool.id === id);
};

export const getToolsByCategory = (category: string): Tool[] => {
  return tools.filter(tool => tool.category === category);
};

export const getToolsByTag = (tag: string): Tool[] => {
  return tools.filter(tool => tool.tags.includes(tag));
};

export const getFeaturedTools = (): Tool[] => {
  return tools.filter(tool => tool.featured);
};

export const getActiveTools = (): Tool[] => {
  return tools.filter(tool => tool.status === 'active');
};

export const getAllCategories = (): string[] => {
  return [...new Set(tools.map(tool => tool.category))];
};

export const getAllTags = (): string[] => {
  return [...new Set(tools.flatMap(tool => tool.tags))];
};
